<template>
    <a
            :href="'https://fashionheritage.eu/browse/record/' + item.id"
            class="item masonry-brick"
            :class="{active: current === item.id}"
            v-on:click="clickEvent"
    >
        <div
                class="media-wrapper"
                style="width: auto;height: 100%;max-height: 240px;"
        >
            <LazyImage
                    :src="srcImage"
                    @imageLoaded="imageLoaded"
            />
            <div class="meta" v-if="isImageLoaded">
                <h4>{{excerptTitle}}</h4>
            </div>
        </div>
    </a>
</template>

<script>
import LazyImage from './LazyImage'

export default {
  name: 'ArchiveItem',
  props: [
    'item',
    'callback',
    'current'
  ],
  components: {
    LazyImage
  },
  data () {
    return {
      destroyImg: false,
      isImageLoaded: false,
      blank: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
    }
  },
  computed: {
    srcImage: function () {
      return !this.destroyImg ? this.item.thumbnail + '?thumb=vertical' : this.blank
    },
    excerptTitle: function () {
      if (this.item.title) {
        const splitted = this.item.title.split(' ')
        if (splitted.length > 6) {
          return this.item.title.split(' ').map(function (item, index) {
            return index < 6 ? item : null
          }).join(' ') + '...'
        }

        return this.item.title
      }
      return ''
    }
    /*
    excerptText: function () {
      if (this.item.description) {
        return this.item.description.split(' ').map(function (item, index) {
          return index < 10 ? item : null
        }).join(' ') + '...'
      }
      return ''
    }
    */
  },
  methods: {
    clickEvent (event) {
      let vm = this
      if (event) event.preventDefault()
      this.callback(vm.item)
    },
    imageLoaded (status) {
      let vm = this
      vm.isImageLoaded = true
      this.$emit('imageLoaded', status)
    }
  },
  beforeDestroy () {
    this.destroyImg = true
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ArchiveItem.vue